module.exports = __webpack_public_path__ + "images/5e25a964bb98849138be674a244e21b1.svg";